import some from 'lodash/some'

const FOCUSABLE_ELEMENTS =
  'a[href], button, textarea, input, select, [tabindex]'

/**
 * Get the first focusable child within an element.
 *
 * @method findFirstFocusableChild
 *
 * @param {Object} options
 *
 *        @param {Node} options.element
 *               The node to search through
 *
 *        @param {Boolean} options.[hasNoValue=false]
 *                Find the first element that has no value set; e.g first input that doesn't have a value set
 *
 *        @param {String} options.[elementsToMatch=FOCUSABLE_ELEMENTS]
 *              Comma separated list thats passed to `querySelectorAll`
 *
 * @return {Node} The first focusable child.
 */
export function findFirstFocusableChild({
  element,
  hasNoValue = false,
  elementsToMatch = FOCUSABLE_ELEMENTS,
}) {
  let focusableChild
  const focusableNodeList = element.querySelectorAll(elementsToMatch)

  // Determine if the element is visible, enabled and has a valid tabindex
  some(focusableNodeList, item => {
    const hasTabAttribute = item.getAttribute('tabindex')
    const tabIndex = (hasTabAttribute && Number(hasTabAttribute)) || 0

    if (item.offsetHeight !== 0 && !item.disabled && tabIndex >= 0) {
      if (hasNoValue) {
        // Store the first encountered match as a fallback; for when an element with a missing value can't be found
        if (!focusableChild) {
          focusableChild = item
        }

        if (item.value === '') {
          focusableChild = item
          return true
        }
      } else {
        focusableChild = item
        return true
      }
    }
  })

  return focusableChild
}
